import {request} from './base'

export default {
    queryPage(params) {
        return request('/suggest/queryPage', params, 'get')
    },
    reply(params) {
        return request('/suggest/reply', params, 'post')
    },
}
